import counterpart from "counterpart";
import moment from "moment";
import React, { useMemo, useState } from "react"
import CollapsablePanelWithArrow from "../../components/ui/collapsable-panel-with-arrow/CollapsablePanelWithArrow"
import Panel from "../../components/ui/panel/Panel";
import Text from "../../components/ui/text/Text";
import { Log } from "../../utils/grpc/generated/Billsby.Protos/billing/private/paymentlogs/payment_logs_pb";

interface ICollapsiblePaymentLog {
  log: Log
}
const CollapsiblePaymentLog: React.FC<ICollapsiblePaymentLog> = ({ log }) => {
  const mainBody = useMemo(() => JSON.stringify(JSON.parse(log.getMainBody()), undefined, 2), [log]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const getPaymentStatusCopy = (status: string) => {
    switch (status) {
      case "Success":
        return counterpart("PAYMENT_LOGS_SUCCESS_STATUS");
      case "Failure":
        return counterpart("PAYMENT_LOGS_FAILED_STATUS");
      case "Declined":
        return counterpart("PAYMENT_LOGS_DECLINED_STATUS");
      case "Pending":
        return counterpart("PAYMENT_LOGS_PENDING_STATUS");
      default:
        return status;
    }
  }
  return (
    <CollapsablePanelWithArrow
      title={getPaymentStatusCopy(log.getPaymentStatus())}
      shouldTranslateTitle={false}
      isCollapsed={isCollapsed}
      onClick={() => setIsCollapsed(!isCollapsed)}
      subtitle={
        <Text
          content="PAYMENT_LOGS_ADDED_ON"
          translateWith={{ date: moment.utc(log.getCreatedOn()?.toDate()).format("DD MMM YYYY"), time: moment.utc(log.getCreatedOn()?.toDate()).format("HH:mm:ss") }}
          noMargin
        />
      }
      shouldTranslateSubtitle={false}
    >
      <Panel title="PAYMENT_LOGS_REFERENCE">
        {log.getReference()}
      </Panel>
      <Panel title="PAYMENT_LOGS_RAW_TITLE" noMargin>
        <pre>{mainBody}</pre>
      </Panel>
    </CollapsablePanelWithArrow>
  )
}

export default CollapsiblePaymentLog;